import {
  AreaMarketReport,
  Column,
  Container,
  EmptyState,
  Row,
  StatisticsReport
} from '@cdab/scania/qpr/components'
import { useTitle } from '@cdab/scania/qpr/contexts/title'
import { useUser } from '@cdab/scania/qpr/contexts/user-provider'
import { useFeatures } from '@cdab/scania/qpr/feature-flags'
import { useCssVariableBreakpoint } from '@cdab/scania/qpr/hooks'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  isRouteErrorResponse,
  useLoaderData,
  useRouteError,
  useRouteLoaderData
} from 'react-router'
import type { ReportLoaderData, ReportsPageLoaderData } from './reports'

export function Page() {
  const { t } = useTranslation(['reports', 'common'])
  const { updateTitles } = useTitle()
  const { userData } = useUser()
  const reportLoaderData = useLoaderData() as ReportLoaderData
  const loaderData = useRouteLoaderData('reports') as ReportsPageLoaderData

  const { statistics_report } = useFeatures(['statistics_report'])

  let markets = loaderData.markets
  const userMarkets = loaderData.userMarkets
  const areas = loaderData.areas
  const dosVersions = loaderData.dosVersions

  if (userData.role < 75) markets = userMarkets

  useEffect(() => {
    updateTitles({
      mobile: {
        title: t('reports'),
        description: null
      }
    })
  }, [updateTitles, t])

  if (
    reportLoaderData.reportType === 'statistics' &&
    statistics_report.enabled
  ) {
    return <StatisticsReport dosVersions={dosVersions} />
  }

  return (
    <AreaMarketReport
      reportType={reportLoaderData.reportType}
      areas={areas}
      markets={markets}
    />
  )
}

export function ErrorBoundary() {
  const { t } = useTranslation('errors')
  const isLg = useCssVariableBreakpoint('--tds-grid-lg')
  const error = useRouteError()

  if (isRouteErrorResponse(error)) {
    return (
      <Container
        fluid='normal'
        paddingOnColumns={!isLg}
        paddingOnContainer={!isLg}
      >
        <Row>
          <Column width={12} padding={isLg}>
            <EmptyState
              title={t('could-not-fetch-reports')}
              description={t('talk-to-admin')}
            />
          </Column>
        </Row>
      </Container>
    )
  }

  // rethrow to let the parent error boundary handle it
  // when it's not a special case for this route
  throw error
}
